import React from 'react';
import {useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {PATHS} from '../../Routes';
import {useComputedReservationDetails} from '../../context/computedReservationDetails';
import {useHousingExemptions} from '../../hooks/useHousingExemptions';
import StyledIcon from 'components/acommon/StyledIcon';
import {PayNowButton, PayNowStyled, Status, StatusPaid} from './styled';

const PayNow = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const {
    isReservationLoaded,
    reservation,
    isAllPaymentsPaid,
    isAnyPaymentsPending,
    hasTaxes,
    hasDeposits,
  } = useComputedReservationDetails();
  const {housingExemptionsLoading} = useHousingExemptions(
    reservation?.source_name,
    reservation?.housing?.id,
  );

  const getPayLink = () => {
    if (hasDeposits) return PATHS.protect;
    if (hasTaxes) return PATHS.touristTaxes;
    return PATHS.pay;
  };

  if (!isReservationLoaded || housingExemptionsLoading) {
    return (
      <PayNowStyled>
        <Status>{t('loading')}</Status>
      </PayNowStyled>
    );
  }

  if (isAnyPaymentsPending) {
    return (
      <PayNowStyled>
        <Status>{t('unpaid')}</Status>
        <PayNowButton to={{pathname: getPayLink(), state: location.state}}>
          <StyledIcon name="payment" size="24" color="#2148FF" />
          <span>{t('pay_now')}</span>
        </PayNowButton>
      </PayNowStyled>
    );
  }

  if (isAllPaymentsPaid) {
    return (
      <StatusPaid>
        <StyledIcon name="payment" size="24" color="white" />
        <span>{t('paid_without_exclamation_mark')}</span>
      </StatusPaid>
    );
  }

  return null;
};

export default PayNow;
